import React, { Component } from 'react';

import { isMobileDevice } from 'react-select/lib/utils';

import Button from '../../../components/Button';
import { INotificationsActions } from '../../../store/notification/actions';
import { IClubsActions } from '../../../store/player/clubs/actions';
import { IMembershipsActions } from '../../../store/player/memberships/actions';
import { IProfileActions } from '../../../store/user/actions';

import {
  ILocalMessageState,
  IMessageNotification,
  initialLocalMessageState
} from '../../../store/notification/store';
import { IClubsStore } from '../../../store/player/clubs/store';
import { IMembershipsStore } from '../../../store/player/memberships/store';
import { IUserStore } from '../../../store/user/store';

import { withContext } from '../../../contrib/utils';

import PlayerSubHeader from '../../../components/PlayerSubHeader';
import Memberships from './Memberships';
import PaymentMethods from './PaymentMethods';
import UserInfo from './UserInfo';

export enum Views {
  'SELECT_PAYMENT',
  'ADD_PAYMENT',
  'CONFIRM',
  'DELETE'
}

interface IProps {
  actions: {
    clubs: IClubsActions;
    memberships: IMembershipsActions;
    notifications: INotificationsActions;
    user: IProfileActions;
  };
  auth: any;
  clubs: IClubsStore;
  memberships: IMembershipsStore;
  user: IUserStore;
}

interface IState {
  message: ILocalMessageState;
}

export class AccountSettingsComponent extends Component<IProps, IState> {
  public cardElement: any;
  constructor(props: IProps) {
    super(props);

    props.actions.memberships.get();

    this.updateUser = this.updateUser.bind(this);
    this.quitMembership = this.quitMembership.bind(this);

    this.state = {
      message: initialLocalMessageState
    };
  }

  public async updateUser({ user }: { user: IUserStore }): Promise<any> {
    const { actions } = this.props;
    const { errors } = await actions.user.updateUser(user);
    if (errors) {
      await actions.notifications.push(({
        status: 'unread',
        text: errors.profile.msg || 'Oops...',
        type: 'error'
      } as unknown) as IMessageNotification);
    } else {
      await actions.notifications.push(({
        status: 'unread',
        text: 'Profile Updated!',
        type: 'success'
      } as unknown) as IMessageNotification);
    }
    setTimeout(() => {
      this.setState({ message: { ...this.state.message, open: false } });
    }, 4000);
  }

  public async quitMembership(clubId: number): Promise<any> {
    const { actions } = this.props;
    const response = await actions.memberships.quit(clubId);

    if (response.errors) {
      await actions.notifications.push(({
        status: 'unread',
        text: response.errors.memberships.msg,
        type: 'error'
      } as unknown) as IMessageNotification);
    } else {
      await actions.notifications.push(({
        status: 'unread',
        text: 'Your memberships were updated',
        type: 'success'
      } as unknown) as IMessageNotification);
    }
  }

  public render(): JSX.Element {
    const { user, memberships, clubs } = this.props;

    const paymentMethodsActions = {
      notifications: this.props.actions.notifications,
      user: this.props.actions.user
    };

    const activeClubs = Object.values(clubs.all).filter(club =>
      memberships.find(membership => membership.club === club.id && membership.status === 'active')
    );

    return (
      <div className="home wrapper account-settings">
        <div>
          <PlayerSubHeader settings={true} title="ACCOUNT SETTINGS" />
          <div className={`settings-container override ${isMobileDevice() ? 'mobile' : ''}`}>
            <UserInfo user={user} onSubmit={this.updateUser} />

            <PaymentMethods actions={paymentMethodsActions} user={user} />

            <Memberships clubs={activeClubs} onDelete={this.quitMembership} />

            <div className="delete-account-wrapper">
              <Button
                variant="text"
                color="primary"
                type="submit"
                className="button delete-account"
              >
                DELETE MY WAGL ACCOUNT
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const AccountSettings = withContext(
  AccountSettingsComponent,
  'user',
  'auth',
  'clubs',
  'memberships'
);

export { AccountSettings };
